import { useParams } from 'react-router-dom';
import { Box, Grid, Tab, Tabs, Typography } from '@mui/material';
import { FC, SyntheticEvent, useCallback, useEffect, useState } from 'react';

// components
import TabPanel from 'components/common/TabPanel';
import EditOrgStaffForm from 'components/main/Users/Staff/EditOrgStaffForm';
import CurrentPlan from 'components/main/Settings/PaymentMethods/CurrentPlan/index';

// constants, interfaces, graphql
import { ParamType } from 'interfaces';
import { PaymentIcon, ProfileIcon } from 'assets/svgs';
import { UserPayload, useGetOrgStaffLazyQuery } from 'generated/graphql';
import {
  DETAILS_TEXT,
  HTTP_STATUS,
  OrgStaffDetailTabs,
  STAFF_DETAILS_TEXT,
  SUBSCRIPTION_TEXT,
} from 'constants/index';

const EditOrgStaff: FC = () => {
  const { id, staffId } = useParams<ParamType>();
  const [staff, setStaff] = useState<UserPayload['user']>(null);
  const [value, setValue] = useState(OrgStaffDetailTabs.DETAILS);

  const handleChange = (_: SyntheticEvent, newValue: OrgStaffDetailTabs) => {
    setValue(newValue);
  };

  const [getOrgStaff, { loading }] = useGetOrgStaffLazyQuery({
    onCompleted: (data) => {
      const { getOrgStaff } = data || {};
      const { response, user } = getOrgStaff || {};
      const { status } = response || {};
      if (status === HTTP_STATUS.SUCCESS) {
        setStaff(user as UserPayload['user']);
      }
    },
    onError: () => {
      setStaff(null);
    },
  });

  const fetchStaff = useCallback(async () => {
    await getOrgStaff({
      variables: {
        getOrgStaffInput: { id: staffId ?? '', organizationId: id ?? '' },
      },
    });
  }, [getOrgStaff, staffId, id]);

  useEffect(() => {
    id && staffId && fetchStaff();
  }, [fetchStaff, id, staffId]);

  return (
    <Box mb={2}>
      <Typography variant="h5" mb={1}>
        {STAFF_DETAILS_TEXT}
      </Typography>
      <Tabs value={value} onChange={handleChange} aria-label="org staff details tabs">
        <Tab
          value={OrgStaffDetailTabs.DETAILS}
          label={DETAILS_TEXT}
          icon={ProfileIcon}
          iconPosition="start"
        />
        <Tab
          value={OrgStaffDetailTabs.SUBSCRIPTION}
          label={SUBSCRIPTION_TEXT}
          icon={PaymentIcon}
          wrapped
          iconPosition="start"
        />
      </Tabs>
      <TabPanel value={OrgStaffDetailTabs.DETAILS} activeTab={value}>
        <EditOrgStaffForm loading={loading} id={staffId} organizationId={id} user={staff} />
      </TabPanel>
      <TabPanel value={OrgStaffDetailTabs.SUBSCRIPTION} activeTab={value}>
        <Grid container>
          <Grid item xs={12} md={8}>
            <CurrentPlan isOrgStaff />
          </Grid>
        </Grid>
      </TabPanel>
    </Box>
  );
};

export default EditOrgStaff;
